
import React from 'react';
import { InstantSearchSSRProvider } from 'react-instantsearch';
import { AppInstantsearch } from './instantsearch/AppInstantsearch';
import { ConfigProvider } from './ConfigProvider';
import { InstantSearchUIProvider } from './instantsearch/InstantSearchUIProvider';

void React;

export type AppShellProps = {
    serverState?: any;
    serverUrl?: URL;
    config?: AlgoliaConfig;
    refinements?: AlgoliaRefinements;
    domElement?: HTMLElement;
};

export function AppShell({ serverState, serverUrl, config, refinements, domElement }: AppShellProps) {
    return (
        <ConfigProvider
            domElement={domElement}
            initialConfig={config}
            initialRefinements={refinements}
        >
            <InstantSearchUIProvider>
                <InstantSearchSSRProvider {...(serverState ?? {})}>
                    <AppInstantsearch serverUrl={serverUrl} />
                </InstantSearchSSRProvider>
            </InstantSearchUIProvider>
        </ConfigProvider>
    );
}